import {
  BrotherArrayCldObjType,
  ubItem,
  upperLimitBrotherCldInfo,
  upperLimitState,
  upperLimitVuexState,
} from '@/@types/billing/upperLimit/index'
import { defineObject } from '@/lib/define/use-define'

const claimState = (): upperLimitVuexState => ({
  data: {
    ubUpperLimitMonthlyAmount: '',
    ub: [],
    officeNumber: '',
    resultNoPlaceholder: '',
    ubTotal: '',
    ubCostTotal: '',
    ubAfterCostTotal: '',
    officeName: '',
    brotherArray: [],
    beneficiaryId: '',
    ubUpperLimitResult: '',
    date: '',
    municipalitiesNo: '',
    parentsName: '',
    childName: '',
  },
})

const valueCalculationSet = (state: upperLimitVuexState) => {
  // 管理結果後利用者負担額の自動計算
  let ubUpperLimitMonthlyAmount = Number(state.data.ubUpperLimitMonthlyAmount)

  let resultNo = 0

  // 自社のみで管理結果利用者負担額算出
  const ownUbArray = state.data.ub.filter(
    (ubItem: ubItem) =>
      ubItem && ubItem.ubOfficeNumber === state.data.officeNumber
  )

  for (const ownUbItem of ownUbArray) {
    if (
      ownUbItem &&
      (ownUbItem.ubCost || ownUbItem.ubCost === 0) &&
      ownUbItem.ubOfficeNumber === state.data.officeNumber
    ) {
      const ubCost = Number(ownUbItem.ubCost)
      ubUpperLimitMonthlyAmount -= ubCost

      if (ubUpperLimitMonthlyAmount < 0) {
        const ubAfterCost = (ubUpperLimitMonthlyAmount += ubCost)
        ubUpperLimitMonthlyAmount -= ubCost

        if (ubAfterCost <= 0) {
          ownUbItem.ubAfterCost = 0
          resultNo = 1
        } else {
          ownUbItem.ubAfterCost = ubAfterCost
          resultNo = 1
        }
      } else {
        ownUbItem.ubAfterCost = ubCost

        if (ubUpperLimitMonthlyAmount === 0) {
          resultNo = 1
        }
      }
    }
  }

  if (resultNo !== 1) {
    resultNo = 2
  }

  // 他社事業所で管理結果利用者負担額算出
  const otherUbArray = state.data.ub.filter(
    (ubItem: ubItem) =>
      ubItem && ubItem.ubOfficeNumber !== state.data.officeNumber
  )

  for (const otherUbItem of otherUbArray) {
    if (resultNo === 2) {
      if (
        otherUbItem &&
        (otherUbItem.ubCost || otherUbItem.ubCost === 0) &&
        otherUbItem.ubOfficeNumber !== state.data.officeNumber
      ) {
        const ubCost = Number(otherUbItem.ubCost)
        ubUpperLimitMonthlyAmount -= ubCost

        if (ubUpperLimitMonthlyAmount < 0) {
          otherUbItem.ubAfterCost = ubUpperLimitMonthlyAmount += ubCost
          resultNo = 3
        } else {
          otherUbItem.ubAfterCost = ubCost
        }
      }
    } else if (
      otherUbItem &&
      (otherUbItem.ubCost || otherUbItem.ubCost === 0)
    ) {
      otherUbItem.ubAfterCost = 0
    }
  }

  // if (state.data.ubUpperLimitResult) {
  //   state.data.ubUpperLimitResult = resultNo
  // }

  state.data.resultNoPlaceholder = resultNo

  state.data.ub = [...ownUbArray.concat(otherUbArray)]

  // 総費用額合計
  // ・「総費用額」(ubTotalCost) 合計値
  const ubTotalArray = state.data.ub.filter(
    (data: ubItem) => data && (data.ubTotalCost || data.ubTotalCost === 0)
  )

  state.data.ubTotal = 0

  for (let index = 0; index < ubTotalArray.length; index++) {
    state.data.ubTotal += Number(ubTotalArray[index].ubTotalCost)
  }

  if (ubTotalArray.length === 0) {
    state.data.ubTotal = ''
  }

  // 利用者負担額合計
  // ・「利用者負担額」(ubCost) 合計値
  const ubCostTotalArray = state.data.ub.filter(
    (data: ubItem) => data && (data.ubCost || data.ubCost === 0)
  )

  state.data.ubCostTotal = 0
  for (let index = 0; index < ubCostTotalArray.length; index++) {
    state.data.ubCostTotal += Number(ubCostTotalArray[index].ubCost)
  }

  if (ubCostTotalArray.length === 0) {
    state.data.ubCostTotal = ''
  }

  // 管理結果後利用者負担額 合計値
  const ubAfterCostTotalArray = state.data.ub.filter(
    (data: ubItem) => data && (data.ubAfterCost || data.ubAfterCost === 0)
  )

  state.data.ubAfterCostTotal = 0
  for (let index = 0; index < ubAfterCostTotalArray.length; index++) {
    state.data.ubAfterCostTotal += Number(
      ubAfterCostTotalArray[index].ubAfterCost
    )
  }

  if (ubAfterCostTotalArray.length === 0) {
    state.data.ubAfterCostTotal = ''
  }
}

type upperLimitStateKeys = keyof upperLimitState

export default {
  namespaced: true,
  state: claimState(),
  mutations: {
    valueResetSet(state: any) {
      state.data = {}
    },
    valueSet(state: upperLimitVuexState, value: upperLimitState) {
      state.data = value

      if (!state.data.ub || state.data.ub.length === 0) return

      const ubMax = 9

      const setUbArray: ubItem[] = []

      for (let i = 0; i < ubMax; i++) {
        if (!state.data.ub[i]) {
          setUbArray.push({
            ubOfficeNumber: '',
            ubCldUpperLimitNumber: '',
            ubBeneficiaryId: '',
            ubOfficeName: '',
            ubTotalCost: '',
            ubCost: '',
            ubAfterCost: '',
          })
        } else {
          setUbArray.push(state.data.ub[i])
        }
      }

      state.data.ub = setUbArray.filter((ubItem: ubItem) => ubItem)

      valueCalculationSet(state)
    },
    valueTargeSet(
      state: upperLimitVuexState,
      value: {
        key: upperLimitStateKeys
        value: upperLimitState
      }
    ) {
      switch (value.key) {
        case 'ub':
          if (Array.isArray(value.value)) state.data.ub = value.value
          break

        case 'brotherArray':
          if (Array.isArray(value.value)) state.data.brotherArray = value.value
          break

        default:
          state.data[value.key] = String(value.value)
          break
      }

      valueCalculationSet(state)
    },
    ubArrayRemove(
      state: upperLimitVuexState,
      value: {
        removeUbCldUpperLimitNumber: number
      }
    ) {
      try {
        const filterUbArray = state.data.ub.filter(
          (ubItem: ubItem) =>
            ubItem.ubCldUpperLimitNumber !== value.removeUbCldUpperLimitNumber
        )

        for (const ubItetm of filterUbArray) {
          if (
            Number(ubItetm.ubCldUpperLimitNumber) >
            Number(value.removeUbCldUpperLimitNumber)
          ) {
            ubItetm.ubCldUpperLimitNumber =
              Number(ubItetm.ubCldUpperLimitNumber) - 1
          }
        }

        state.data.ub = filterUbArray.map((ubItem: any) => {
          return ubItem
        })

        if (!state.data.brotherArray) {
          state.data.brotherArray = []
        }

        state.data.brotherArray = state.data.brotherArray.filter(
          (cldObj: BrotherArrayCldObjType) =>
            cldObj.ubCldUpperLimitNumber !== value.removeUbCldUpperLimitNumber
        )

        for (let index = 0; index < state.data.brotherArray.length; index++) {
          state.data.brotherArray[index].ubCldUpperLimitNumber =
            defineObject.UB_CLD_UPPER_LIMIT_NUMBER[index]
        }

        valueCalculationSet(state)
      } catch (error) {
        console.log(error)
        throw new Error('変更失敗')
      }
    },
    ubArrayAdd(
      state: upperLimitVuexState,
      value: {
        setId: string
        setCldName: string
        setUbBeneficiaryId: string
        setUbCldUpperLimitNumber: number
        officeArray: { [key: string]: ubItem } | null
      }
    ) {
      try {
        let targetOfficeArray: ubItem[] = []

        state.data.ub = state.data.ub.filter(
          (ubObj: ubItem) =>
            ubObj.ubCldUpperLimitNumber !== value.setUbCldUpperLimitNumber
        )

        // 自社に登録している児童
        if (value.officeArray) {
          // 自社情報の追加
          state.data.ub.push({
            ubOfficeNumber: state.data.officeNumber,
            ubCldUpperLimitNumber: value.setUbCldUpperLimitNumber,
            ubBeneficiaryId: value.setUbBeneficiaryId,
            ubOfficeName: state.data.officeName,
            ubTotalCost: '',
            ubCost: '',
            ubAfterCost: '',
          })

          // 他者情報のセット
          const shapeOfficeArray: ubItem[] = Object.values(value.officeArray)

          targetOfficeArray = shapeOfficeArray.map((ubItem: ubItem) => {
            return {
              ubOfficeNumber: ubItem.office_number ? ubItem.office_number : '',
              ubCldUpperLimitNumber: value.setUbCldUpperLimitNumber
                ? value.setUbCldUpperLimitNumber
                : '',
              ubBeneficiaryId: value.setUbBeneficiaryId
                ? value.setUbBeneficiaryId
                : '',
              ubOfficeName: ubItem.office_name ? ubItem.office_name : '',
              ubTotalCost: '',
              ubCost: '',
              ubAfterCost: '',
            }
          })

          const setUbLength = state.data.ub.filter((ubItem: ubItem) =>
            (Object.keys(ubItem) as (keyof ubItem)[]).some(
              ubKey => ubItem[ubKey]
            )
          ).length

          const setLength = 9 - setUbLength

          if (setLength < targetOfficeArray.length) {
            state.data.ub = state.data.ub.filter(
              (ubItem: ubItem) =>
                ubItem.ubCldUpperLimitNumber !== value.setUbCldUpperLimitNumber
            )

            throw new Error('officeCntError')
          }
        } else {
          state.data.ub.push({
            ubOfficeNumber: '',
            ubCldUpperLimitNumber: value.setUbCldUpperLimitNumber,
            ubBeneficiaryId: value.setUbBeneficiaryId,
            ubOfficeName: '',
            ubTotalCost: '',
            ubCost: '',
            ubAfterCost: '',
          })
        }

        for (let index = 0; index < targetOfficeArray.length; index++) {
          targetOfficeArray[index] = {
            ubOfficeNumber: value.officeArray
              ? targetOfficeArray[index].ubOfficeNumber
              : '',
            ubCldUpperLimitNumber:
              targetOfficeArray[index].ubCldUpperLimitNumber,
            ubBeneficiaryId: targetOfficeArray[index].ubBeneficiaryId,
            ubOfficeName: value.officeArray
              ? targetOfficeArray[index].ubOfficeName
              : '',
            ubTotalCost: '',
            ubCost: '',
            ubAfterCost: '',
          }
        }

        const sortArray = [1, 2, 3, 4]

        const upperLimitManagementUbArray = []

        const upperLimitManagementfilterUbArray = state.data.ub.filter(
          (ubObj: ubItem) => ubObj.ubOfficeNumber === state.data.officeNumber
        )

        for (let index = 0; index < sortArray.length; index++) {
          const targetOwnUbItem = upperLimitManagementfilterUbArray.find(
            (ubObj: ubItem) =>
              ubObj.ubCldUpperLimitNumber === sortArray[index] &&
              ubObj.ubOfficeNumber === state.data.officeNumber
          )

          if (targetOwnUbItem) {
            upperLimitManagementUbArray.push(targetOwnUbItem)
          }
        }

        for (let index = 0; index < sortArray.length; index++) {
          let sortTargetUbArray = targetOfficeArray.filter(
            (ubObj: ubItem) =>
              ubObj.ubCldUpperLimitNumber === sortArray[index] &&
              ubObj.ubOfficeNumber !== state.data.officeNumber
          )

          if (sortTargetUbArray.length === 0) {
            sortTargetUbArray = state.data.ub.filter(
              (ubObj: ubItem) =>
                ubObj.ubCldUpperLimitNumber === sortArray[index] &&
                ubObj.ubOfficeNumber !== state.data.officeNumber
            )
          }

          upperLimitManagementUbArray.push(...sortTargetUbArray)
        }

        state.data.ub = [...upperLimitManagementUbArray]

        if (!state.data.brotherArray) {
          state.data.brotherArray = []
        }

        const targetIndex = state.data.brotherArray.findIndex(
          (cldObj: BrotherArrayCldObjType) =>
            cldObj.ubCldUpperLimitNumber === value.setUbCldUpperLimitNumber
        )

        const setCldObj: BrotherArrayCldObjType = {
          id: value.setId,
          cldName: value.setCldName,
          beneficiaryId: value.setUbBeneficiaryId,
          ubCldUpperLimitNumber: value.setUbCldUpperLimitNumber,
        }

        if (state.data.brotherArray[targetIndex]) {
          state.data.brotherArray.splice(targetIndex, 1, setCldObj)
        } else {
          state.data.brotherArray.push(setCldObj)
        }

        valueCalculationSet(state)
      } catch (error) {
        console.log(error)

        if (error instanceof Error && error.message === 'officeCntError') {
          alert(
            '事業所の数が多すぎます。該当児童の事業所情報をご確認ください。'
          )
          throw new Error('変更失敗')
        } else {
          alert('データを正しく変更することができませんでした。')
          throw new Error('変更失敗')
        }
      }
    },
    valueTargeArraySet(
      state: upperLimitVuexState,
      value: {
        item: ubItem
        idx: number
        key: 'ub'
      }
    ) {
      if (
        value.item.ubCldUpperLimitNumber &&
        state.data.brotherArray &&
        state.data.brotherArray.length !== 0
      ) {
        if (Number(value.item.ubCldUpperLimitNumber) !== 1) {
          const targetCld = state.data.brotherArray.find(
            (cldObj: upperLimitBrotherCldInfo) =>
              cldObj.ubCldUpperLimitNumber === value.item.ubCldUpperLimitNumber
          )

          if (targetCld) {
            value.item.ubBeneficiaryId = targetCld.beneficiaryId
          }
        } else {
          value.item.ubBeneficiaryId = state.data.beneficiaryId
        }
      } else if (
        !value.item.ubCldUpperLimitNumber &&
        state.data.brotherArray &&
        state.data.brotherArray.length !== 0
      ) {
        const valueItem = Object.keys(value.item) as (keyof ubItem)[]

        valueItem.forEach(key => {
          value.item[key] = ''
        })
      }

      state.data.ub.splice(value.idx, 1, value.item)

      valueCalculationSet(state)
    },
    ownUbItemSet(
      state: upperLimitVuexState,
      value: {
        ubUpperLimitMonthlyAmount: number | string
        setUbItem: ubItem
      }
    ) {
      state.data.ubUpperLimitMonthlyAmount = value.ubUpperLimitMonthlyAmount

      if (state.data.ub) {
        const setUbItem = value.setUbItem

        // 自社の情報を取得する
        const targetUbArray = state.data.ub.filter(
          (data: ubItem) =>
            String(data.ubOfficeNumber) === String(setUbItem.ubOfficeNumber)
        )

        let targetUb: ubItem | undefined = targetUbArray[0]

        // きょうだい上限管理の場合は児童番号が1の自社情報を取得する
        if (targetUbArray.length > 1) {
          targetUb = state.data.ub.find(
            (data: ubItem) =>
              String(data.ubOfficeNumber) ===
                String(setUbItem.ubOfficeNumber) &&
              data.ubCldUpperLimitNumber === 1
          )
        }

        if (targetUb) {
          targetUb.ubTotalCost = Number(setUbItem.ubTotalCost)
          targetUb.ubCost = setUbItem.ubCost
          targetUb.ubAfterCost = ''

          state.data.ub.splice(0, 1, targetUb)
        }

        valueCalculationSet(state)
      }
    },
    ubArraySort(
      state: upperLimitVuexState,
      value: {
        draggingItemIndex: number
        draggingItemTargetIndex: number
      }
    ) {
      if (state.data.ub) {
        const draggingItem = state.data.ub[value.draggingItemIndex]

        const draggingItemTarget = state.data.ub[value.draggingItemTargetIndex]

        state.data.ub.splice(value.draggingItemTargetIndex, 1, draggingItem)
        state.data.ub.splice(value.draggingItemIndex, 1, draggingItemTarget)
      }
      valueCalculationSet(state)
    },
  },
}
